<template>
  <Header />
  <div class="inner-content aside-grid">
    <Menu />
    <!--RIGHT COLUMN-->
    <div class="content-column">
      <div v-if="helpLoading" class="table-group">
        load...
      </div>
      <div v-if="helpError" class="mc-error">{{ helpError }}</div>
      <template v-if="helpLoaded && help.id"><div class="content" v-html="help[lang]?.text"></div></template>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Menu from "@/components/help/Menu.vue"
import Header from "@/components/help/Header.vue"

export default {
  components: {
    Menu, Header
  },
  data: () => ({

  }),
  created() {
    this.load();
  },
  watch: {
    '$route.params.id': {
      async handler(newId) {
        this.load();
      }
    }
  },
  computed: {
    ...mapGetters('help', [
      'help',
      'helpLoading',
      'helpError',
      'helpLoaded',
    ]),
    ...mapGetters([
      'lang'
    ]),
  },
  methods: {
    ...mapActions('help', [
      'fetchHelp',
    ]),
    async load() {
      await this.fetchHelp(this.$route.params.id?this.$route.params.id:0);
      if (!this.help.id) {
        this.$router.push('/help/');
        return;
      }
      if (this.$route.params.id != this.help.id) {
        this.$router.replace(`/help/${this.help.id}/`);
      }
    }
  }
}
</script>
